import { Screens } from "types/general";
import styles from "./AccessPrompt.module.css";

interface Props {
	message: string;
	setScreen: (v: Screens) => void;
}

export default function AccessPrompt({ message, setScreen }: Props) {
	return (
		<div className={styles.accessPrompt}>
			{message === "No valid pass" ? (
				<>
					<p className="text-light mb-2">You will need an access pass to watch this broadcast</p>

					<button onClick={() => setScreen("pay")}>PURCHASE ACCESS</button>
				</>
			) : message === "User not logged in" ? (
				<button onClick={() => setScreen("login")}>LOGIN TO ACCESS</button>
			) : null}
		</div>
	);
}
